const START_WORKOUT_DOMAIN = 'startWorkout'

const START_WORKOUT_KEY = {
  HAS_PAUSED: 'hasPaused',
  HAS_STARTED: 'hasStarted',
  PREPARATION_TIME_BEFORE_SET: 'preparationTimeBeforeSet',
  CURRENT_WORKOUT_SECTION_INDEX: 'currentWorkoutSectionIndex',
  CURRENT_WORKOUT_EXERCISE_INDEX: 'currentWorkoutExerciseIndex',
  IS_AUDIO_TIMER_ENABLED_SETTING: 'isAudioTimerEnabledSetting',
  IS_AUDIO_TEN_SECONDS_LEFT_ENABLED_SETTING: 'isAudioTenSecondsLeftEnabledSetting',
  IS_AUDIO_GUIDANCE_ENABLED_SETTING: 'isAudioGuidanceEnabledSetting',
  IS_AUDIO_MOTIVATION_ENABLED_SETTING: 'isAudioMotivationEnabledSetting',
  IS_VIDEO_ENABLED_SETTING: 'isVideoEnabledSetting',
  IS_PLAYING_SET: 'isPlayingSet',
  TIME_ELAPSED: 'timeElapsed',
  TOTAL_TIME_ELAPSED: 'totalTimeElapsed',
  IS_SHOWING_NEXT_UP: 'isShowingNextUp'
}

const START_WORKOUT_PATH = {
  CURRENT_WORKOUT_EXERCISE_INDEX: `${START_WORKOUT_DOMAIN}.${START_WORKOUT_KEY.CURRENT_WORKOUT_EXERCISE_INDEX}`,
  CURRENT_WORKOUT_SECTION_INDEX: `${START_WORKOUT_DOMAIN}.${START_WORKOUT_KEY.CURRENT_WORKOUT_SECTION_INDEX}`,
  PREPARATION_TIME_BEFORE_SET: `${START_WORKOUT_DOMAIN}.${START_WORKOUT_KEY.PREPARATION_TIME_BEFORE_SET}`,
  HAS_STARTED: `${START_WORKOUT_DOMAIN}.${START_WORKOUT_KEY.HAS_STARTED}`,
  HAS_PAUSED: `${START_WORKOUT_DOMAIN}.${START_WORKOUT_KEY.HAS_PAUSED}`,
  IS_AUDIO_TIMER_ENABLED_SETTING: `${START_WORKOUT_DOMAIN}.${START_WORKOUT_KEY.IS_AUDIO_TIMER_ENABLED_SETTING}`,
  IS_AUDIO_TEN_SECONDS_LEFT_ENABLED_SETTING: `${START_WORKOUT_DOMAIN}.${START_WORKOUT_KEY.IS_AUDIO_TEN_SECONDS_LEFT_ENABLED_SETTING}`,
  IS_AUDIO_GUIDANCE_ENABLED_SETTING: `${START_WORKOUT_DOMAIN}.${START_WORKOUT_KEY.IS_AUDIO_GUIDANCE_ENABLED_SETTING}`,
  IS_AUDIO_MOTIVATION_ENABLED_SETTING: `${START_WORKOUT_DOMAIN}.${START_WORKOUT_KEY.IS_AUDIO_MOTIVATION_ENABLED_SETTING}`, // IS_AUTO_PLAY_ENABLED_SETTING: `${START_WORKOUT_DOMAIN}.${START_WORKOUT_KEY.IS_AUTO_PLAY_ENABLED_SETTING}`,
  IS_PLAYING_SET: `${START_WORKOUT_DOMAIN}.${START_WORKOUT_KEY.IS_PLAYING_SET}`,
  IS_VIDEO_ENABLED_SETTING: `${START_WORKOUT_DOMAIN}.${START_WORKOUT_KEY.IS_VIDEO_ENABLED_SETTING}`,
  IS_SHOWING_NEXT_UP: `${START_WORKOUT_DOMAIN}.${START_WORKOUT_KEY.IS_SHOWING_NEXT_UP}`,
  TIME_ELAPSED: `${START_WORKOUT_DOMAIN}.${START_WORKOUT_KEY.TIME_ELAPSED}`,
  TOTAL_TIME_ELAPSED: `${START_WORKOUT_DOMAIN}.${START_WORKOUT_KEY.TOTAL_TIME_ELAPSED}`
}

const START_WORKOUT_STATE = {
  [START_WORKOUT_KEY.CURRENT_WORKOUT_EXERCISE_INDEX]: 0,
  [START_WORKOUT_KEY.CURRENT_WORKOUT_SECTION_INDEX]: 0,
  [START_WORKOUT_KEY.PREPARATION_TIME_BEFORE_SET]: 5000, // In milliseconds
  [START_WORKOUT_KEY.HAS_STARTED]: false,
  [START_WORKOUT_KEY.HAS_PAUSED]: false,
  [START_WORKOUT_KEY.IS_AUDIO_TIMER_ENABLED_SETTING]: true,
  [START_WORKOUT_KEY.IS_AUDIO_TEN_SECONDS_LEFT_ENABLED_SETTING]: true,
  [START_WORKOUT_KEY.IS_AUDIO_GUIDANCE_ENABLED_SETTING]: true,
  [START_WORKOUT_KEY.IS_AUDIO_MOTIVATION_ENABLED_SETTING]: true, // [START_WORKOUT_KEY.IS_AUTO_PLAY_ENABLED_SETTING]:
  // true,
  [START_WORKOUT_KEY.IS_VIDEO_ENABLED_SETTING]: true,
  [START_WORKOUT_KEY.IS_PLAYING_SET]: false,
  [START_WORKOUT_KEY.IS_SHOWING_NEXT_UP]: false,
  [START_WORKOUT_KEY.TIME_ELAPSED]: 0,
  [START_WORKOUT_KEY.TOTAL_TIME_ELAPSED]: 0
}

const START_WORKOUT_ACTION = {
  ENABLE_AUTO_PLAY: 'START_WORKOUT_ENABLE_AUTO_PLAY',
  DISABLE_AUTO_PLAY: 'START_WORKOUT_DISABLE_AUTO_PLAY',
  ENABLE_AUDIO_TIMER_SETTING: 'START_WORKOUT_ENABLE_AUDIO_TIMER_SETTING',
  DISABLE_AUDIO_TIMER_SETTING: 'START_WORKOUT_DISABLE_AUDIO_TIMER_SETTING',
  ENABLE_AUDIO_GUIDANCE_SETTING: 'START_WORKOUT_ENABLE_AUDIO_GUIDANCE_SETTING',
  DISABLE_AUDIO_GUIDANCE_SETTING: 'START_WORKOUT_DISABLE_AUDIO_GUIDANCE_SETTING',
  ENABLE_AUDIO_MOTIVATION_SETTING: 'START_WORKOUT_ENABLE_AUDIO_MOTIVATION_SETTING',
  DISABLE_AUDIO_MOTIVATION_SETTING: 'START_WORKOUT_DISABLE_AUDIO_MOTIVATION_SETTING',
  ENABLE_AUDIO_TEN_SECONDS_LEFT_SETTING: 'START_WORKOUT_ENABLE_AUDIO_TEN_SECONDS_LEFT_SETTING',
  DISABLE_AUDIO_TEN_SECONDS_LEFT_SETTING: 'START_WORKOUT_DISABLE_AUDIO_TEN_SECONDS_LEFT_SETTING',
  ENABLE_VIDEO_SETTING: 'START_WORKOUT_ENABLE_VIDEO_SETTING',
  DISABLE_VIDEO_SETTING: 'START_WORKOUT_DISABLE_VIDEO_SETTING',
  START: 'START_WORKOUT_START',
  UPDATE_IS_PLAYING: 'START_WORKOUT_UPDATE_IS_PLAYING',
  RESET_IS_PLAYING: 'START_WORKOUT_RESET_IS_PLAYING',
  UPDATE_TIME_ELAPSED: 'START_WORKOUT_UPDATE_TIME_ELAPSED',
  RESET_TIME_ELAPSED: 'START_WORKOUT_RESET_TIME_ELAPSED',
  STOP: 'START_WORKOUT_STOP',
  RESUME: 'START_WORKOUT_RESUME',
  RESUME_ACTIVE: 'START_WORKOUT_RESUME_ACTIVE',
  RESUME_FOCUS: 'START_WORKOUT_RESUME_FOCUS',
  PAUSE: 'START_WORKOUT_PAUSE',
  PAUSE_INACTIVE: 'START_WORKOUT_PAUSE_INACTIVE',
  PAUSE_NOT_FOCUSED: 'START_WORKOUT_PAUSE_NOT_FOCUSED',
  PAUSE_MENU_OPENED: 'START_WORKOUT_PAUSE_MENU_OPENED',
  PAUSE_REORDERING: 'START_WORKOUT_PAUSE_REORDERING',
  PREVIOUS_SET: 'START_WORKOUT_PREVIOUS_SET',
  PREVIOUS_UPDATE_IN_ROUND: 'START_WORKOUT_PREVIOUS_UPDATE_IN_ROUND',
  PREVIOUS_SET_IN_ROUND: 'START_WORKOUT_PREVIOUS_SET_IN_ROUND',
  PREVIOUS_WORKOUT_EXERCISE: 'START_WORKOUT_PREVIOUS_WORKOUT_EXERCISE',
  PREVIOUS_WORKOUT_SECTION: 'START_WORKOUT_PREVIOUS_WORKOUT_SECTION',
  RESET_CURRENT_WORKOUT_SECTION_WORKOUT_EXERCISE_AND_SET: 'START_WORKOUT_RESET_CURRENT_WORKOUT_SECTION_WORKOUT_EXERCISE_AND_SET',
  UPDATE_CURRENT_WORKOUT_EXERCISE_INDEX: 'START_WORKOUT_UPDATE_CURRENT_WORKOUT_EXERCISE_INDEX',
  NEXT_SET: 'START_WORKOUT_NEXT_SET',
  NEXT_UPDATE_IN_ROUND: 'START_WORKOUT_NEXT_UPDATE_IN_ROUND',
  NEXT_WORKOUT_EXERCISE: 'START_WORKOUT_NEXT_WORKOUT_EXERCISE',
  UPDATE_WORKOUT_SECTION: 'START_WORKOUT_UPDATE_WORKOUT_SECTION',
  NEXT_ROUND: 'START_WORKOUT_NEXT_ROUND',
  UPDATE_PREPARATION_TIME_BEFORE_SET: 'START_WORKOUT_UPDATE_PREPARATION_TIME_BEFORE_SET',
  RESET_STATE: 'START_WORKOUT_RESET_STATE',
  UPDATE_STARTING_WORKOUT_SECTION: 'START_WORKOUT_UPDATE_STARTING_WORKOUT_SECTION'
}

const START_WORKOUT_ANALYTICS_EVENT = {
  IS_AUDIO_TIMER_DISABLED_SETTING: 'Start Workout Audio Timer Setting Disabled',
  IS_AUDIO_TIMER_ENABLED_SETTING: 'Start Workout Audio Timer Setting Enabled',
  IS_AUDIO_GUIDANCE_DISABLED_SETTING: 'Start Workout Audio Guidance Setting Disabled',
  IS_AUDIO_GUIDANCE_ENABLED_SETTING: 'Start Workout Audio Guidance Setting Enabled',
  IS_AUDIO_MOTIVATION_DISABLED_SETTING: 'Start Workout Audio Motivation Setting Disabled',
  IS_AUDIO_MOTIVATION_ENABLED_SETTING: 'Start Workout Audio Motivation Setting Enabled',
  IS_AUDIO_TEN_SECONDS_LEFT_DISABLED_SETTING: 'Start Workout Audio Ten Seconds Remaining Setting Disabled',
  IS_AUDIO_TEN_SECONDS_LEFT_ENABLED_SETTING: 'Start Workout Audio Ten Seconds Remaining Setting Enabled',
  IS_AUTO_PLAY_DISABLED_SETTING: 'Start Workout Setting Auto Play Disabled',
  IS_AUTO_PLAY_ENABLED_SETTING: 'Start Workout Setting Auto Play Enabled',
  VIDEO_SETTING_DISABLED: 'Start Workout Video Setting Disabled',
  VIDEO_SETTING_ENABLED: 'Start Workout Video Setting Enabled',
  NEXT_UP: 'Start Workout Next Up',
  LOGGED: 'Start Workout Logged',
  FINISHED: 'Start Workout Finished',
  PAUSED: 'Start Workout Paused',
  PAUSED_INACTIVE: 'Start Workout Paused Inactive',
  RESUMED_ACTIVE: 'Start Workout Resumed Active',
  RESUMED_FOCUSED: 'Start Workout Resumed Focused',
  OPEN_SETTINGS: 'Start Workout Open Settings',
  PAUSED_NOT_FOCUSED: 'Start Workout Paused Not Focused',
  PAUSED_MENU_OPENED: 'Start Workout Paused Modal Opened',
  PAUSED_REORDERING: 'Start Workout Paused Reordering',
  QUITED: 'Start Workout Quited',
  STARTED: 'Start Workout Started',
  RESUMED: 'Start Workout Resumed'
}

/**
 * The end set audio's duration.
 * @type {number}
 */
const START_WORKOUT_TIME_LEFT_AUDIO_REMAINING_DURATION_SECONDS = 10

export {
  START_WORKOUT_ACTION,
  START_WORKOUT_ANALYTICS_EVENT,
  START_WORKOUT_DOMAIN,
  START_WORKOUT_KEY,
  START_WORKOUT_PATH,
  START_WORKOUT_STATE,
  START_WORKOUT_TIME_LEFT_AUDIO_REMAINING_DURATION_SECONDS
}
